import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import useRecordingPeriod from "my-time/hooks/use-recording-period/use-recording-period";

export const MyTimeRecordingPeriodChip: React.FC = () => {
  const { t } = useTranslation();

  const { data: recordingPeriod } = useRecordingPeriod();

  return (
    <Box
      display="flex"
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
    >
      <Box
        style={{
          border: `1px solid #CC0033`,
          borderRadius: "8px",
          padding: "1px 16px",
          display: "flex",
        }}
      >
        <Typography color="#CC0033">
          {t("MY_TIME_RECORDING_PERIOD")}:
        </Typography>
        <Box width="4px" />
        <Typography color="#CC0033">{recordingPeriod}</Typography>
      </Box>
    </Box>
  );
};

export default MyTimeRecordingPeriodChip;
